<template>
    <div>
        <button
            v-if="!mini"
            type="button"
            class="flex items-center w-full px-4 py-1.25 text-gray-370 dark:text-gray-200"
            @click="onToggleSection"
        >
            <span class="font-sans-inter text-xxxs font-medium uppercase whitespace-nowrap tracking-0.05em">
                {{ section.section }}
            </span>

            <ArrowSubMenuChevronIcon
                class="w-5 h-5 ml-auto transform duration-100"
                :class="{ 'rotate-180': !section.isOpenSection }"
            />
        </button>

        <div
            class="grid transition-[grid-template-rows] duration-200"
            :style="{ gridTemplateRows: mini || section.isOpenSection ? '1fr' : '0fr' }"
        >
            <div class="min-h-0 overflow-hidden">
                <div class="flex flex-col gap-y-0.5">
                    <RoutingSideBarItem
                        v-for="item in section.items"
                        :key="item.id"
                        :route="item"
                        :mini="mini"
                        :isShowPopup="isShowPopup"
                        :popupPosition="popupPosition"
                        @openSubMenu="onOpenSubMenu"
                        @mouseenter="onMouseenter"
                        @mouseleave="onMouseleave"
                        @popupMouseenter="onPopupMouseenter"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import RoutingSideBarItem from '@/components/navigation/RoutingSideBar/RoutingSideBarItem.vue'
import ArrowSubMenuChevronIcon from '@/components/icons/arrow/ArrowSubMenuChevronIcon.vue'

const props = defineProps({
    section: {
        type: Object,
        default: () => ({}),
    },
    mini: {
        type: Boolean,
        default: false,
    },
    isShowPopup: {
        type: Number,
        default: -1,
    },
    popupPosition: {
        type: Object,
        default: () => ({}),
    },
})

const emits = defineEmits(['toggleSection', 'openSubMenu', 'mouseenter', 'mouseleave', 'popupMouseenter'])

function onToggleSection() {
    emits('toggleSection', props.section)
}

function onOpenSubMenu(route) {
    emits('openSubMenu', route)
}

function onMouseenter(route, event) {
    emits('mouseenter', route, event)
}

function onMouseleave() {
    emits('mouseleave')
}

function onPopupMouseenter(event) {
    emits('popupMouseenter', event)
}
</script>
